import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../scss/pages/pageview.css';

const SubCard = ({fitImg,title,context,workoutLink}) => {
    let navigate= useNavigate();
  return (
    <div className='cardWrapper2' onClick={()=>{navigate(workoutLink)}}>
      <div className="imageBox">
        <img src={fitImg} className='img-fluid' alt="" />
      </div>
      <div className="contextWrapper">
        <div className="fitCont">
          <h3>{title}</h3>
          <p>{context}</p>
        </div>
        <div className="playImg">
          <img src={require('../assets/images/workout/playbtn.png')} className='img-fluid' alt="" />
        </div>
      </div>
    </div>
  )
}

export default SubCard